// extracted by mini-css-extract-plugin
export default {"iconContainer":"warning_tooltip_icon-module___iconContainer___ac004e1c"};